import React, { useState } from 'react';

const NumericInput = ({ 
  value, 
  onChange, 
  min, 
  max, 
  step = 1,
  style = {}
}) => {
  const [inputValue, setInputValue] = useState(value);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  
  const handleInputChange = (e) => {
    const newValue = e.target.value;
    
    // Allow empty string for clearing input
    if (newValue === '') {
      setInputValue('');
      return;
    }

    // Only allow numbers and decimal point
    if (!/^-?\d*\.?\d*$/.test(newValue)) {
      return;
    }

    setInputValue(newValue);
    onChange(newValue);
  };

  const handleBlur = () => {
    // If empty, reset to min value or 0
    if (inputValue === '') {
      const defaultValue = min !== undefined ? min : 0;
      setInputValue(defaultValue);
      onChange(defaultValue);
      return;
    }

    // Ensure value is within bounds and convert to number
    let finalValue = parseFloat(inputValue);
    if (min !== undefined) finalValue = Math.max(min, finalValue);
    if (max !== undefined) finalValue = Math.min(max, finalValue);
    
    setInputValue(finalValue);
    onChange(finalValue);
  };

  // Simple +/- buttons
  const increment = () => {
    const newValue = parseFloat(inputValue) + step;
    if (max !== undefined && newValue > max) return;
    setInputValue(newValue);
    onChange(newValue);
  };

  const decrement = () => {
    const newValue = parseFloat(inputValue) - step;
    if (min !== undefined && newValue < min) return;
    setInputValue(newValue);
    onChange(newValue);
  };

  // Button styles for better mobile touch targets
  const buttonStyle = {
    width: '28px',
    height: '28px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f0f0f0',
    border: '1px solid #ccc',
    borderRadius: '4px',
    margin: '0 1px',
    padding: '0',
    fontSize: '14px'
  };
  
  const inputStyle = {
    width: '75px',  // Increased width to ensure values are fully visible
    textAlign: 'center',
    height: '28px',
    padding: '0 4px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    // Hide spinner buttons on mobile
    ...(isMobile && {
      WebkitAppearance: 'none',
      MozAppearance: 'textfield'
    })
  };

  // Mobile: show buttons, hide native controls
  // Desktop: hide buttons, show native controls
  return (
    <div style={{ 
      display: 'inline-flex', 
      alignItems: 'center', 
      margin: '1px',
      ...style 
    }}>
      {isMobile && (
        <button 
          type="button"
          onClick={decrement}
          style={buttonStyle}
        >
          -
        </button>
      )}
      <input
        type="number"
        value={inputValue}
        onChange={handleInputChange}
        onBlur={handleBlur}
        min={min}
        max={max}
        step={step}
        inputMode="decimal"
        style={inputStyle}
      />
      {isMobile && (
        <button 
          type="button"
          onClick={increment}
          style={buttonStyle}
        >
          +
        </button>
      )}
    </div>
  );
};

export default NumericInput;